var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "requirement" },
    [
      _c("span", [_vm._v("Requires")]),
      _vm._l(_vm.requirements, function(r, i) {
        return _c("span", { key: r.name }, [
          r.displayMode == 0
            ? _c("span", { staticClass: "what" }, [
                _vm._v(" " + _vm._s(r.name))
              ])
            : _vm._e(),
          _c("span", { staticClass: "value" }, [
            _vm._v(" " + _vm._s(r.values[0][0]))
          ]),
          r.displayMode == 1
            ? _c("span", { staticClass: "what" }, [
                _vm._v(" " + _vm._s(r.name))
              ])
            : _vm._e(),
          i < _vm.requirements.length - 1
            ? _c("span", { staticClass: "comma" }, [_vm._v(",")])
            : _vm._e()
        ])
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
/* hot reload */
if (module.hot) {
  var api = require("/Users/simone/Dev/node/poekit-rack/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (module.hot.data) {
      require("/Users/simone/Dev/node/poekit-rack/node_modules/vue-hot-reload-api/dist/index.js").rerender('ed699c3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    }
  }
}export { render, staticRenderFns }